import { type MfaFormValues } from "./type";

export const defaultValuesMfaForm: MfaFormValues = {
  mfaCode: "",
};

export const titleTestId = "pages/signin/__components__/mfa-forms/title";

export const descriptionTestId = "pages/signin/__components__/mfa-forms/description";

export const submitButtonTestId = "pages/signin/__components__/mfa-forms/confirm-screen/submit";

export const changeRecoveryCodeScreenTestId =
  "pages/signin/__components__/mfa-forms/confirm-screen/change-recovery-code-screen";
